module.exports = __webpack_public_path__ + "static/media/vf-button-sneakers.275cb2f8.svg";